import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { ButtonToolbar } from 'reactstrap';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import MdiIcon from 'src/componentes/mdi-icon';

import { DownloadContentFileBucket } from 'src/services/downloadFileUrl';

function ViewDocument({ fileName, ...rest }) {
  const intl = useIntl();
  const modalRef = useRef();
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState(null);

  useEffect(() => {
    if (fileName) {
      fetchFile();
    }
  }, [fileName]);

  const fetchFile = async () => {
    try {
      const fileBlob = await DownloadContentFileBucket(fileName);
      const fileUrl = URL.createObjectURL(fileBlob);
      setFileData(fileUrl);
      setFileType(fileBlob.type); // Define o tipo do arquivo para a exibição condicional
    } catch (error) {
      console.error('Erro ao buscar o arquivo:', error);
    }
  };

  const handleCurrentClose = (isSaved = false) => {
    modalRef.current.close();
  };

  const editActions = [
    <ButtonToolbar key="toolbar-tela">
      <Button color="secondary" onClick={handleCurrentClose}>
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>
      {/*  <Button className="ml-3" color="outline-primary">
        <MdiIcon icon="download" />
      </Button>
      <Button
        type="primary"
        onClick={handleCurrentClose}
        htmlType="submit"
        className="ml-2"
      >
        {intl.formatMessage({ id: 'aceitar' })}
      </Button>*/}
    </ButtonToolbar>,
  ];

  return (
    <Dialog
      id="documento-view"
      title={intl.formatMessage({ id: 'documento' })}
      ref={modalRef}
      minWidth="70%"
      minHeight="80%"
      padContent
      actions={editActions}
      {...rest}
    >
      {fileData && (
        <iframe
          src={fileData}
          width="100%"
          height="100%"
          title="PDF Document"
        />
      )}
    </Dialog>
  );
}

export default ViewDocument;
